import { DateTime } from 'luxon';

enum Cadence {
  WEEKLY = '(W)',
  QUARTERLY = '(Q)',
  MONTHLY = '',
}

const parseExpiryDate = (value: string): Date => {
  const dt = DateTime.fromFormat(value, 'yyyyMMdd');
  if (!dt.isValid) {
    console.error(`Invalid date (value: "${value}"): ${dt.invalidReason}`);
    return new Date(NaN);
  }
  return dt.toJSDate();
};

const isFriday = (date: Date) => date.getDay() === 5;

const isThirdFriday = (date: Date) => {
  if (!isFriday(date)) return false;
  const day = date.getDate();
  return day >= 15 && day <= 21;
};

const isQuarterMonth = (month: number) => [2, 5, 8, 11].includes(month);

const getCadenceLabel = (value: string): Cadence => {
  const date = parseExpiryDate(value);
  const month = date.getMonth();

  if (isThirdFriday(date) && isQuarterMonth(month)) {
    return Cadence.QUARTERLY;
  }

  if (!isThirdFriday(date)) {
    return Cadence.WEEKLY;
  }

  return Cadence.MONTHLY;
};

export const withCadenceLabel = <T extends { label: string; value: string }>(expiries: T[]): T[] =>
  expiries.map(expiry => ({
    ...expiry,
    label: `${expiry.label} ${getCadenceLabel(expiry.value)}`,
  }));
